import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(contractId) {
  return axios.get(
    api.path("contractDashboardContractMap.index", { contractId: contractId })
  );
}
